//--------sample url--https://apps-dev.abrpl.co.in/PJrYN3--------------//
//---------http://localhost:3000/f?swahi005+00234----------------------//

import { Button, Card, Container, Stack, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

import { BaseURL, authKey } from "../../common/URLs";
import { toast } from 'react-toastify';
import { VALIDATION } from "../../common/commonValidations";
import { Badge } from "react-bootstrap";
import apiClient from "../../axios";

const Feedbackpage = () => {

  const { search } = useLocation();
  // console.log(search.slice(1));
  //const urlParam= search.split("+");
  const [yesbutton, setYesbutton] = useState("gainsboro");
  const [nobutton, setNobutton] = useState("gainsboro");
  const [option, setOption] = useState(1);
  const [comment, setComment] = useState("");
  const [ticketStatus, setTicketStatus] = useState();      //declare setTicketStatus
  const [characterLimit] = useState(500);

  // function to fetch ticket status

  //const [decryptdata,setDecrptedData] = useState()
  function onSubmit() {
    if (comment?.length > 500) {
      toast.error("Please enter the description within 500 words");
    }
    else {
      apiClient.post(
        BaseURL + '/grievanceandhelpdesk/helpdesk/v1/updateFeedback',
        {
          "ticketNumber": search?.slice(1),
          "yesOrNo": option,
          "comments": comment
        },
        {
          headers: {
            AuthKey: authKey,
          }
        }
      ).then((res) => {
        alert("Thanks for your valuable feedback 😀!");
        window.open("https://apps.abrpl.co.in/", '_self');
      }).catch((error) => {
        console.log(error);
        alert("Sorry 😞!! Something went wrong")
      })
    }
  }

  useEffect(() => {
    fetchTicketStatus();
  }, []);

  const fetchTicketStatus = () => {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/helpdesk/v1/fetchTicketStatus",
      {
        "ticketNumber": search.slice(1),
        "yesOrNo": true,
      },
      {
        headers: {
          "AuthKey": authKey,
        }
      }
    )
      .then((response) => {
        setTicketStatus(response.data)
        if (response.data.isFeedBacklinkExpired === "Y") {
          alert("The link is expired");
        }
        else if (response.data.ticketstatus === "Closed") {
          toast.warning("Feedback already provided");
        } else if (response.data.ticketstatus !== "Resolved") {
          toast.warning("Not yet open for feedback");
        }
      })
      .catch((error) => {
        console.log("Error - " + error);
      });
  };

  // var key = "secrete";

  // const decryptData = async () => {

  //     //Trying RSA encryption
  //     const { publicKey, privateKey } = crypto.generateKeyPairSync("rsa", {
  //         // The standard secure default length for RSA keys is 2048 bits
  //         modulusLength: 2048,
  //       });

  //     var plaintext = "ABR0000298+URN-SWAHI00454"
  //     const encryptedData = crypto.publicEncrypt(
  //     {
  //         key: publicKey,
  //         padding: crypto.constants.RSA_PKCS1_OAEP_PADDING,
  //         oaepHash: "sha256",
  //     },
  //     Buffer.from(plaintext)
  //     );

  //     console.log("encypted data: ", encryptedData.toString("base64"));
  //     //var url = aesUtil.longurl("https://apps-dev.abrpl.co.in/PJrYN3");
  //     //console.log(url);
  //     // var result=aesUtil.decrypt("secrete", "47B0C43B66A44C8F655F85D2022ECEF79A348543CBC49F86E073EC44387A8F2CBCE653D90170F9A914A1DFA860E8E0AAEzNqPrhK5JFduGkmd6jmew==");
  //     // console.log(result);
  //     // var c2= "K93XpAe//LYfJOVTesD+pQ" 
  //     // var bytes  = CryptoJS.AES.decrypt(c2, result);
  //     // var maintext= bytes.toString(CryptoJS.enc.Utf8);
  //     // console.log("++++++++decrypted - ",maintext);
  //   };


  return <>
    <Helmet>
      <title> Feedback | ABEPL </title>
    </Helmet>
    <Container maxWidth="xl" style={{}}>
      <Card style={{ padding: "3%", backgroundColor: "#CFEBC8" }}>
        <h6 style={{ "color": "blueviolet" }}>Ticket No: {search.slice(1)}</h6>
        <br></br>
        <h5>Resolution Comment:</h5> <p>{ticketStatus?.resolutionComment}</p>
        <br></br>
        <h4>Are you satisfied with the response?</h4>
        <Stack direction='row' spacing={8} style={{ paddingLeft: "15%" }}>
          <Button style={{ backgroundColor: `${yesbutton}` }}
            onClick={() => {
              setOption(1);
              setYesbutton("#32BC0D");
              setNobutton("gainsboro");
            }}>
            <p style={{ padding: "5%" }}> ✔</p>
          </Button>
          <Button style={{ backgroundColor: `${nobutton}` }}
            onClick={() => {
              setOption(0);
              setNobutton("red");
              setYesbutton("gainsboro")
            }}>
            ✖
          </Button>
        </Stack>
        <br />
        <h5>Comment:</h5>
        <br />
        <TextField id="outlined-multiline-static"
          multiline
          fullWidth
          rows={4}
          label="any suggestion for us..."
          variant="outlined"
          value={comment}
          onChange={(e) => { setComment(VALIDATION.noSpecialCharacterValidation(e.target.value)) }} />
        <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '2%' }}>
          <Badge bg={`${comment.length > characterLimit ? 'danger' : 'primary'}`}>{comment.length}/{characterLimit}</Badge>
        </div>
        <br />
        <br />
        <Button variant="contained"
          disabled={ticketStatus?.ticketstatus !== "Resolved" || ticketStatus?.isFeedBacklinkExpired === "Y"}
          onClick={onSubmit}>
          Submit </Button>
      </Card>
    </Container>
  </>
}

export default Feedbackpage;